export default __webpack_public_path__ + "static/media/evreux10.4dae2923.jpg";